/**
 * Tells if a form value is filled. Null, undefined and an empty string are empty. The number 0 is filled.
 */
export function isFilledValue(value: unknown): boolean {
  return value !== null && value !== undefined && value !== '';
}
